import { connect } from 'react-redux';
import React from 'react';
import GlobalError from './GlobalError';
import {hideGlobalError, showGlobalError} from './actions';

const mapStateToProps = state => ({
  message: state.common.globalError.message,
  isActive: state.common.globalError.isActive,
  errorId: state.common.globalError.errorId
});

const actionCreators = {
  showGlobalError,
  hideGlobalError,
};


const GlobalErrorContainer = connect(
  mapStateToProps,
  actionCreators
)(GlobalError);

export default GlobalErrorContainer;
